import api from './api'
import auth from 'routes/Auth/modules/auth'
import modals from './modals'
import notifications from './notifications'
import sticky from './sticky'

export const reducers = {
  api,
  auth,
  notifications,
  modals,
  sticky
}

export default reducers



// WEBPACK FOOTER //
// ./src/store/reducers/index.js